import { USER_TYPES } from '../../../utils/constants';
import { MFA_FACTOR_IDS } from '../constants';

/**
 * Returns true only if user is a patient AND has MFA enrolled (TOTP or SMS).
 * Returns false for non-patients (they have different requirements).
 *
 * @param {Object} params
 * @param {UserType | ""} params.userType
 * @param {import('firebase/auth').MultiFactorUser} params.multiFactorUser
 * @returns {boolean}
 */
export const isPatientWithMFASatisfied = ({ userType, multiFactorUser }) => {
  if (userType !== USER_TYPES.PATIENT) {
    return false;
  }

  const enrolledFactorIds = multiFactorUser.enrolledFactors.map((f) => f.factorId);

  return enrolledFactorIds.includes(MFA_FACTOR_IDS.TOTP) || enrolledFactorIds.includes(MFA_FACTOR_IDS.PHONE);
};
